import { motion } from "framer-motion";
import { services } from "../../data/Servicesdata";
import "../../styles/Services.css";

const ServicesModule = () => {
  return (
    <div className="container text-center">
      <h2 className="services-title text-secondary">
        The <span className="text-accent">Service</span> We Provide <br /> For
        You
      </h2>

      <div className="services-grid">
        {services.map((service, index) => {
          const Icon = service.icon;

          const colWidth = 360; // card width + desired horizontal gap
          const rowHeight = 330; // card height + vertical gap

          const col = index % 3;
          const row = Math.floor(index / 3);

          const finalX = (col - 1) * colWidth; // center column = 0
          const finalY = row * rowHeight;       // row spacing


          return (
            <motion.div
              key={index}
              className="service-item"
              style={{
                transformOrigin: "top right",
                "--i": index,
              }}
              initial={{
                x: -index * 26,
                y: index * 26,
                rotate: 0,
                scale: 1,
                opacity: 1,
              }}
              whileInView={{
                x: `calc(-50% + ${finalX}px)`,
                y: finalY,
                rotate: 0,
                scale: 1,
                opacity: 1,
              }}
              viewport={{
                once: true,
                amount: 0.35,
              }}
              transition={{
                duration: 1.6,
                ease: [0.22, 1, 0.36, 1],
                delay: 0.6 + index * 0.25,
              }}
            >
              <div className="service-card bg-primary">
                <div className="service-icon">
                  <Icon style={{ color: service.color }} />
                </div>
                <h5 className="text-secondary">{service.title}</h5>
                <p className="text-secondary">{service.description}</p>
                  
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default ServicesModule;
